<template>
  <section class="container">
    <div class="home-apartment">
      <div
        :class="{ active: ApartmentSellerIsShown }"
        class="apartment-main el-row--flex"
      >
        <div class="el-col el-col-10 hidden-xs-only">
          <ApartmentImage v-if="item" :item="item" :detail-description="true" />
        </div>
        <div class="el-col el-col-10 el-col-xs-24 hidden-sm-and-up">
          <router-link :to="{ name: 'flat-detail', params: { id: item.id } }">
            <ApartmentSlider :slides="item.images" :color="item.color" :sold_at="item.sold_at" />
          </router-link>
        </div>
        <div class="el-col el-col-8 hidden-xs-only">
          <ApartmentInfo :item="item" />
        </div>
        <div class="el-col el-col-6 el-col-xs-24">
          <div class="apartment-price-block">
            <div class="mobile-apartment-block">
              <ApartmentPrise :id="item.id" :price="item.price" />
              <div class="apartment-socials-block">
                <AddToSelectedBtn
                  @toggle-favorite="toggleFavorite"
                  :active="!!favoriteFlats.find((el) => el.id === item.id)"
                />
                <ApartmentSocial
                  :popper-horizontal="true"
                  popper-direction="left"
                  :id="item.id"
                />
                <ApartmentSocialMobile :id="item.id" />
              </div>
            </div>
            <div class="name-mobile-apartment hidden-sm-and-up">
              {{ item.rooms }} к - {{ item.district.name
              }}<span v-if="item.guide"> - {{ item.guide }}</span>
            </div>
            <div class="mobile-phone-apartment">
              <div class="apartment-seller-btn">
                <button
                  :class="{ active: ApartmentSellerIsShown }"
                  class="rounded-btn blue"
                  @click="ApartmentSellerIsShown = !ApartmentSellerIsShown"
                >
                  Контакти продавця
                </button>
              </div>
              <iframe name="hiddeniframe" style="visibility:hidden;width:0;height:0;"></iframe>
              <div
                class="apartment-seller-btn only-monbile-apartment"
                v-if="item.realtor"
              >
                <!-- <a :href="`tel:${item.realtor.primary_phone}`"></a> -->
                <button
                  :class="{ active: isPhone }"
                  class="rounded-btn blue"
                  @click="isPhone = !isPhone"
                >
                  <a :href="`tel:${item.realtor.primary_phone}`" target="hiddeniframe">
                    ТЕЛЕФОНУВАТИ
                  </a>
                </button>
              </div>
              <div
                class="apartment-seller-btn only-monbile-apartment"
                v-if="item.realtor"
              >
                <el-button
                  type="text"
                  @click="centerDialogVisible = true"
                  class="rounded-btn blue active"
                  >НАПИСАТИ</el-button
                >

                <el-dialog
                  class="sellers-dialog"
                  :visible.sync="centerDialogVisible"
                  width="90%"
                  center
                  top="40vh"
                >
                  <div class="mobile-write-sellers">НАПИСАТИ</div>
                  <div>
                    <div class="seller-socials-container mobile-socials">
                      <ul class="socials-container White-colored Big">
                        <li class="socials-item" v-if="item.realtor.viber">
                          <a
                            class="socials-item-icon-container"
                            :href="`viber://chat?number=%2B38${item.realtor.viber}`"
                          >
                            <IconBase
                              height="18"
                              icon-name="ViberColored"
                              width="18"
                            >
                              <ViberColored />
                            </IconBase>
                          </a>
                        </li>
                        <li class="socials-item" v-if="item.realtor.telegram">
                          <a
                            class="socials-item-icon-container"
                            :href="`https://telegram.im/@${item.realtor.telegram}`"
                          >
                            <IconBase
                              height="18"
                              icon-color="#0088CC"
                              icon-name="TelegramColored"
                              width="18"
                            >
                              <TelegramBlack />
                            </IconBase>
                          </a>
                        </li>
                        <li class="socials-item" v-if="item.realtor.facebook">
                          <a
                            class="socials-item-icon-container"
                            :href="`https://www.messenger.com/t/${item.realtor.facebook}`"
                          >
                            <IconBase
                              height="18"
                              icon-color="#3B5999"
                              icon-name="FacebookColored"
                              width="18"
                            >
                              <FacebookBlack />
                            </IconBase>
                          </a>
                        </li>
                        <li class="socials-item" v-if="item.realtor.instagram">
                          <a
                            class="socials-item-icon-container"
                            :href="`https://www.instagram.com/${item.realtor.instagram}`"
                          >
                            <IconBase
                              height="18"
                              icon-name="InstagramColored"
                              width="18"
                            >
                              <InstagramColored />
                            </IconBase>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </el-dialog>
              </div>
            </div>
          </div>
        </div>
        <div
          class="hot-offer-wrapper"
          v-if="item.is_top || item.is_superprice || item.is_exclusive"
        >
          <div
            v-if="item.is_top && !item.is_exclusive"
            class="hot-offer-block top-offer"
            :class="{ active: item.is_top && !item.is_exclusive }"
          >
            ТОП
          </div>
          <div
            v-if="item.is_superprice && !item.is_exclusive"
            class="hot-offer-block best-price"
            :class="{ active: item.is_superprice && !item.is_exclusive }"
          >
            СУПЕР ЦІНА
          </div>
          <div
            v-if="item.is_exclusive"
            class="hot-offer-block our-exclusive"
            :class="{ active: item.is_exclusive }"
          >
            НАШ ЕКС
          </div>
        </div>
      </div>
      <el-collapse-transition>
        <div v-if="ApartmentSellerIsShown">
          <ApartmentSeller :realtor="item.realtor" />
        </div>
      </el-collapse-transition>
    </div>
  </section>
</template>

<script>
import IconBase from '../../icons/IconBase'
import Heart from '../../icons/Heart'
import ViberColored from '../../icons/ViberColored'
import InstagramColored from '../../icons/InstagramColored'
import TelegramBlack from '../../icons/TelegramBlack'
import FacebookBlack from '../../icons/FacebookBlack'
import Link from '../../icons/Link'
import Share from '../../icons/Share'
import ApartmentSeller from '../../common/ApartmentSeller'
import Gps from '../../icons/Gps'
import House from '../../icons/House'
import Square from '../../icons/Square'
import ApartmentHouse from '../../icons/ApartmentHouse'
import ApartmentState from '../../icons/ApartmentState'
import Boxes from '../../icons/Boxes'
import Eye from '../../icons/Eye'
import ApartmentPopUp from '../../common/PopUps/ApartmentPopUp'
import BorderedHeart from '@/components/icons/BorderedHeart'
import ApartmentSlider from '@/components/common/apartment_partials/ApartmentSlider'
import ApartmentImage from '@/components/common/apartment_partials/ApartmentImage'
import ApartmentInfo from '@/components/common/apartment_partials/ApartmentInfo'
import AddToSelectedBtn from '@/components/common/apartment_partials/AddToSelectedBtn'
import ApartmentSocial from '@/components/common/apartment_partials/ApartmentSocials'
import ApartmentSocialMobile from '@/components/common/apartment_partials/ApartmentSocialsMobile'
import ApartmentPrise from '@/components/common/apartment_partials/ApartmentPrise'
import { mapGetters } from 'vuex'
import { checkAuth } from '@/helper'
import { host } from '@/services/config'

export default {
  name: 'Apartment',
  components: {
    ApartmentSocialMobile,
    ApartmentSlider,
    ApartmentPrise,
    ApartmentSocial,
    AddToSelectedBtn,
    ApartmentInfo,
    ApartmentImage,
    BorderedHeart,
    ApartmentPopUp,
    Eye,
    Boxes,
    ApartmentState,
    ApartmentHouse,
    Square,
    House,
    Gps,
    ApartmentSeller,
    Share,
    Link,
    FacebookBlack,
    TelegramBlack,
    InstagramColored,
    ViberColored,
    Heart,
    IconBase,
  },
  props: {
    item: Object,
    realtor: Object,
  },
  computed: {
    ...mapGetters({
      favoriteFlats: 'getFavoriteFlatList',
    }),
  },
  data() {
    return {
      baseURL: host,
      centerDialogVisible: false,
      ApartmentSellerIsShown: false,
      isPhone: false,
    }
  },

  methods: {
    beforeWindowUnload (e) {
      if (this.favoriteFlats.length && !checkAuth(true)) {
        e.preventDefault()
        e.returnValue = ''
      }
    },
    toggleFavorite() {
          
      const isFlatFavorite = !!this.favoriteFlats.find(
        (el) => el.id === this.item.id)
      this.$store.dispatch(!isFlatFavorite? 'addToFavorite':'deleteFromFavorite', this.item)
      if(this.favoriteFlats.length === 5)return checkAuth(true)
    },
  },

  beforeRouteLeave (to, next) {
    if (!this.favoriteFlats.length) return next()
      next(false)
      window.location = to.path 
  },
  created () {
   if(!checkAuth()) window.addEventListener('beforeunload', this.beforeWindowUnload)
  },
  beforeDestroy () {
    if(checkAuth()) window.removeEventListener('beforeunload', this.beforeWindowUnload)
  }
}
</script>
